<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { OnClickOutside } from '@vueuse/components';
import NextButton from 'dashboard/components-next/button/Button.vue';
import MultiselectDropdownItems from 'shared/components/ui/MultiselectDropdownItems.vue';

// Filtro rápido de uso diário (PRD T3.4 secao 3): dropdown múltiplo com
// busca, sempre visível, nunca atrás de um botão "Filtros". Reusa
// MultiselectDropdownItems (já usada em DebtKanbanBlock.vue via
// MultiselectDropdown) em vez de reimplementar busca + destaque de
// selecionados.
const props = defineProps({
  label: { type: String, required: true },
  options: { type: Array, default: () => [] },
  modelValue: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();
const isOpen = ref(false);

const selectedCount = computed(() => props.modelValue.length);

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

const close = () => {
  isOpen.value = false;
};

const toggleOption = option => {
  const exists = props.modelValue.some(item => item.id === option.id);
  const next = exists
    ? props.modelValue.filter(item => item.id !== option.id)
    : [...props.modelValue, { id: option.id, name: option.name }];
  emit('update:modelValue', next);
};
</script>

<template>
  <OnClickOutside @trigger="close">
    <div class="relative">
      <NextButton
        slate
        :faded="selectedCount === 0"
        :outline="selectedCount > 0"
        xs
        trailing-icon
        :icon="isOpen ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
        aria-haspopup="true"
        :aria-expanded="isOpen"
        @click="toggleOpen"
      >
        {{ label }}
        <span v-if="selectedCount > 0" class="text-n-slate-11">
          {{
            t('KANBAN.BOARD.MULTISELECT.SELECTED_COUNT', {
              count: selectedCount,
            })
          }}
        </span>
      </NextButton>
      <div
        v-if="isOpen"
        class="absolute z-30 mt-1 w-64 rounded-lg border border-n-weak bg-n-solid-2 shadow-lg p-2"
      >
        <MultiselectDropdownItems
          :options="options"
          :selected-items="modelValue"
          :has-thumbnail="false"
          :input-placeholder="t('KANBAN.BOARD.MULTISELECT.SEARCH_PLACEHOLDER')"
          :no-search-result="t('KANBAN.BOARD.MULTISELECT.NO_RESULTS')"
          @select="toggleOption"
        />
      </div>
    </div>
  </OnClickOutside>
</template>
